/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WithdrawSeoulAgreementRequest = {
  vin: string;
  stopCd: WithdrawSeoulAgreementRequest.stopCd;
};
export namespace WithdrawSeoulAgreementRequest {
  export enum stopCd {
    _01 = '01',
    _02 = '02',
    _03 = '03',
  }
}

